import { LexerEvent } from "../../text/lexer/LexerEvent";
import { LexerMatcherLibrary } from "../../text/lexer/LexerMatcherLibrary";
import { SourceRange } from "../../text/lexer/parsing/SourceInfo";
import { BinaryExpression } from "../expressions/BinaryExpression";
import { RJExpressionNode } from "../expressions/RJExpressionNode";
import { RJExpressionNodeType } from "../expressions/RJExpressionNodeType";
import { RJToken } from "../expressions/RJToken";
import { UnaryExpression } from "../expressions/UnaryExpression";
import { RJParserMessages } from "../parsers/RJParserMessages";
import { RJLexer } from "../RJLexer";
import { RJParser } from "../RJParser";
import { Operator } from "./Operator";

export class UnaryOperator extends Operator
{
  _symbol:string;
  _fromLeft:boolean;
  _isPost:boolean = false;
  _checkForOperators = false;

  constructor( parser:RJParser, symbol:string, fromLeft:boolean = true, post:boolean = false, checkForOperator:boolean = false )
  {
    super( parser );
    this.setStartToken( RJLexer.OperatorMatcher.type, symbol );
    this._symbol = symbol;
    this._fromLeft = fromLeft;
    this._isPost = post;
    this._checkForOperators = checkForOperator;
  }

  public isFromLeft():boolean
  {
    return this._fromLeft;
  }

  findStartNodeIndex( nodes:RJExpressionNode[] ):number
  {
    if ( ! this._checkForOperators )
    {
      return super.findStartNodeIndex( nodes );
    }

    var start     = this.isFromLeft() ? 0 : ( nodes.length - 1);
    var end       = this.isFromLeft() ? nodes.length : -1;

    var step      = this.isFromLeft() ? 1 : -1;

    for ( let i = start; i != end; i += step )
    {
      if ( this.isStartNode( nodes[ i ] ) && this._checkStartWithOperators( nodes, i ) )
      {
        return i;
      }
    }

    return -1;
  }

  _isStartNodeCheckedWithOperators( nodes:RJExpressionNode[], index:number )
  {
    if ( ! this.isStartNode( nodes[ index ] ) )
    {
      return false;
    }

    return this._checkStartWithOperators( nodes, index ) ;
  }

  _checkStartWithOperators( nodes:RJExpressionNode[], index:number )
  {
    let isStartIndex = index === 0;

    let isPre = ! this._isPost;

    if ( isPre )
    {
      if ( isStartIndex )
      {
        return true;
      }

      let nodeBefore = nodes[ index - 1 ];

      if ( nodeBefore.isToken( LexerMatcherLibrary.OPERATOR_MATCHER.type ) )
      { 
        return true;
      }
      else
      {
        console.log( "node before not a operator:", nodes[ index ], ">>", nodeBefore );
      }
    }

    return false;

  }

  public processStartNode( nodes:RJExpressionNode[], index:number )
  {
    let operatorNode = nodes[ index ] as any as RJToken;
    let isFirstIndex = index === 0;
    let isLastIndex = index === ( nodes.length - 1 );
    
    if ( this._isPost && isFirstIndex )
    {
      this.processor.parser.error( RJParserMessages.missingLeftArgument, operatorNode.sourceInfo );
      return false;
    }

    if ( ! this._isPost && isLastIndex )
    {
      this.processor.parser.error( RJParserMessages.missingRightArgument, operatorNode.sourceInfo );     
      
      return false;
    }

    let otherNodeIndexOff = this._isPost ? -1 : 1;
    let otherNodeIndex    = otherNodeIndexOff + index;
    let expressionNode    = nodes[ otherNodeIndex ];

    let unary = new UnaryExpression( this._parser, SourceRange.combine( operatorNode.sourceRange, expressionNode.sourceRange ), this._isPost );
    unary.setExpression( operatorNode, expressionNode );

    let start = this._isPost ? otherNodeIndex : index;  

    RJExpressionNode.replaceRange( nodes, start, 2, unary );


    return true;
  }
}
